import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, TOKEN_KEY } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        if (res.data.session_token) localStorage.setItem(TOKEN_KEY, res.data.session_token);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(res.data.is_admin ? "/land-acquisition" : "/portal", { state: { user: res.data } });
      } catch {
        navigate("/", { state: { authError: true } });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0B0C10] flex items-center justify-center" data-testid="auth-callback-loading">
      <p className="font-mono-lux text-[11px] uppercase tracking-[0.3em] text-[#8A8D98] animate-pulse">
        Verifying your Google identity…
      </p>
    </div>
  );
}
